import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <div className="container">
        <h2>Your Trusted Utility & Contracting Partner</h2>
        
        <p>
          Carmel Lahaina Utility Services has been serving the Carmel and surrounding areas with 
          professional utility installation and general contracting services for years. We specialize 
          in water, gas, electrical, and telecommunications installations for both residential and 
          commercial properties. Our experienced team ensures every project meets local building codes, 
          utility company specifications, and safety standards. From new construction to renovation 
          projects, we provide comprehensive solutions that enhance property value and ensure reliable 
          utility connections for years to come.
        </p>
        
        <h3>Comprehensive Contracting Services</h3>
        
        <p>
          Beyond utility installation, we offer full general contracting services including construction, 
          renovation, maintenance, and repair work. Our licensed contractors handle everything from 
          small repairs to major construction projects. We work closely with property owners, managers, 
          and tenants to deliver solutions that meet specific needs while maintaining the highest 
          standards of quality and safety. Our commitment to excellence and customer satisfaction 
          has made us the preferred choice for utility and contracting services in the Carmel area.
        </p>
      </div>
    </section>
  );
};

export default About;
